import { useQuery } from '@tanstack/react-query';
import { api } from '_clean-code/api/client';
import { StopCauseComponent, StopCausesResponse } from '_clean-code/types/Stop';
import { TreeLoss } from '_clean-code/types/stops';
import { createUrl } from '_clean-code/utils/urlHelper';

export const STOP_CAUSES_QUERY_KEY = 'stop-causes';

export function useStopCauses() {
  const { data, isFetching, isError, error, refetch } = useQuery<{
    treeLosses: TreeLoss[];
    components: StopCauseComponent[];
  }>({
    queryKey: [STOP_CAUSES_QUERY_KEY],
    queryFn: async () => {
      const [
        { data },
        {
          data: {
            data: { components }
          }
        }
      ] = await Promise.all([
        api.get<TreeLoss[]>(createUrl(`v2/stops/lossTrees`).toStringUrl()),
        //TODO: @vicente only to load components/equipments? maybe add it to v2/stops/lossTrees to save one call
        api.get<StopCausesResponse>(
          createUrl(`v2/stops/causesNew`).toStringUrl()
        )
      ]);

      return { treeLosses: data ?? [], components: components ?? [] };
    },
    retry: 2,
    staleTime: 1000 * 60 * 15 // 15 minutes
  });
  return {
    data,
    isFetching,
    isError,
    error,
    refetch
  };
}

export default useStopCauses;
